module.exports = __webpack_public_path__ + "img/client-1.baa3886.png";